import styled from '@emotion/styled';

export const Title = styled.h2`
    color: #ff0000;
    background-color: #c5c4c4;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    padding: 25px 0;
    margin: 0;
`;


export const StatisticCard = styled.section`
    background-color: #7cdef2;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: auto;
    width: 360px;
    
`;

export const StatList = styled.ul`
    background-color: #a3f27c;
    display: flex;
    flex-direction: row;
     border: 4px dashed silver;
    
`;

export const Item = styled.li`
    background-color: #f0f27c;
    display: flex;
    flex-direction: column;
    align-items: center;
    
`;

export const Label = styled.span`
    background-color: #7cf2f2;
        
`;


export const Percentage = styled.span`
    background-color: #7cabf2;
    font-size: 1.5em;
        
`;